module.exports = __webpack_public_path__ + "static/media/6.2-plugin.ef0aaae7.png";